/** ArollSharePage.tsx — the branded client share page (/aroll/s/:token). */
export const share = {
  'share.linkInactive': 'This link is no longer active. Ask the sender for a fresh one.',
  'share.opening': 'Opening…',
  'share.nothingToReview': 'Nothing to review here yet.',
  /** aria-label on the "Made with PICTURE UP" lockup link. */
  'share.madeWithAriaLabel': 'Made with PictureUp',
  /** Prefix before the PICTURE UP wordmark in the lockup. */
  'share.madeWith': 'Made with',
  /** One line above the A-Roll tab on a client link. */
  'share.arollBanner':
    'This is a paper edit from the interview, not a finished cut.',
  /** Client header label on the A-Roll tab. */
  'share.kindAroll':
    'Interview selects',
  /** Client header label on the cuts tab. */
  'share.kindReview':
    'Review',
} as const;
